import {
    FaTiktok,
    FaWhatsapp,
    FaFacebook,
    FaInstagram,
} from 'react-icons/fa'

const buttons = [
    { href: 'https://wa.me/50239990332', icon: FaWhatsapp, label: 'WhatsApp' },
    { href: 'https://www.tiktok.com/@despega.gt?_r=1&_t=ZS-93hurkr3J8D', icon: FaTiktok, label: 'TikTok' },
    { href: 'https://www.facebook.com/despegagt', icon: FaFacebook, label: 'Facebook' },
    { href: 'https://www.instagram.com/despegagt?igsh=MWJ4bmR0eHd2bDdybg==', icon: FaInstagram, label: 'Instagram' },
]

export default function SocialButtons() {
    return (
        <div className="fixed bottom-6 right-5 z-50 flex flex-col gap-3">
            {buttons.map(({ href, icon: Icon, label }) => (
                <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={label}
                    className="w-10 h-10 flex items-center justify-center rounded-full text-white shadow-md transition hover:scale-110 hover:shadow-lg"
                    style={{ background: '#1a1a1a' }}
                >
                    <Icon size={17} />
                </a>
            ))}
        </div>
    )
}
